import { render, staticRenderFns } from "./WearDetails.vue?vue&type=template&id=f2753e16"
import script from "./WearDetails.vue?vue&type=script&lang=js"
export * from "./WearDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports